var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 18,
    fill: "#e6e7e8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.897,22.122c-.114-.904-.555-1.657-.987-2.199,.959-1.047,2.09-2.685,2.09-4.584,0-1.427-.65-2.932-1.882-4.354-1.066-1.23-3.169-1.231-4.237,0-1.231,1.421-1.881,2.926-1.881,4.353,0,1.899,1.131,3.536,2.09,4.584-.433,.542-.874,1.295-.987,2.199l-.095,.753c-.043,.341,.092,.681,.358,.898,.266,.217,.624,.285,.951,.175l1.684-.562,1.684,.562c.104,.035,.21,.052,.316,.052,.228,0,.453-.078,.634-.227,.266-.218,.401-.558,.358-.898l-.095-.753Zm-3.505-9.826c.21-.242,.471-.277,.607-.277s.397,.035,.607,.276c.635,.734,1.393,1.857,1.393,3.044,0,1.407-1.037,2.712-1.8,3.482-.027,.005-.053,.011-.079,.018l-.12,.034-.12-.034c-.026-.007-.053-.013-.08-.018-.764-.771-1.8-2.075-1.8-3.482,0-1.187,.758-2.31,1.393-3.043Zm-14.393-.296c-.591,0-1.142,.172-1.607,.469C4.417,8.002,7.909,2.314,19,2V7c0,.553,.448,1,1,1s1-.447,1-1V2c0-.538-.222-1.062-.609-1.439C20.001,.182,19.491-.007,18.949-.004,4.449,.411,1.592,9.479,1.096,14.217c-.649,.331-1.096,1.006-1.096,1.783v6c0,1.103,.897,2,2,2s2-.897,2-2v-4.172c.313,.111,.649,.172,1,.172,1.654,0,3-1.346,3-3s-1.346-3-3-3Zm0,4c-.551,0-1-.448-1-1s.449-1,1-1,1,.448,1,1-.449,1-1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.bc2c9afb9b97b86aeb39520e4197a2b2.svg";
export { ForwardRef as ReactComponent };